export const urlBaseApi = process.env.REACT_APP_API_URL;
export const saveLabel = 'Datos guardados correctamente';
export const deleteLabel = 'Se eliminó el registro';
export const businessTimeZone = 'America/Lima';
export const IGV_RATE = 0.18;
